const initialState = {
	isLoading: false,
	isBackgroundLoading: false,
	selected: false,
	byId: {},
	loadingById: {},
	offersById: {}
}

export default function pageReducer( state = initialState, action ) {
	const { type, payload } = action

	switch ( type ) {
		case 'REQUEST_PAGE_DATA':
			let isLoading = ( payload.requentOnly || payload.backgroundLoading ) ? state.isLoading : true
			let isBackgroundLoading = payload.backgroundLoading || state.isBackgroundLoading

			return {
				...state,
				isLoading: isLoading,
				isBackgroundLoading: isBackgroundLoading,
				error: false,
				loadingById: {
					...state.loadingById,
					[ payload.slug ]: true
				}
			}

		case 'RECEIVE_PAGE_DATA':
			let newById = {
				...state.byId
			}

			if ( newById[ 'id_' + payload.slug ] ) {
				newById[ 'id_' + payload.slug ] = {
					...payload.data,
					podcasts: {
						...newById[ 'id_' + payload.slug ].podcasts,
						...payload.data.podcasts
					},
					recently_played: {
						...newById[ 'id_' + payload.slug ].recently_played,
						...payload.data.recently_played
					}
				}
			} else {
				newById = {
					[ 'id_' + payload.slug ]: payload.data,
					...state.byId
				}
			}

			return {
				...state,
				error: false,
				byId: newById,
				loadingById: {
					...state.loadingById,
					[ 'id_' + payload.slug ]: false
				}
			}

		case 'RECEIVE_PAGE_ERROR':
			return {
				...state,
				isLoading: false,
				isBackgroundLoading: false,
				error: true
			}

		case 'SET_CURRENT_PAGE':
			let selected = state.selected

			if ( state.byId[ 'id_' + payload ] ) {
				selected = state.byId[ 'id_' + payload ]
			}

			return {
				...state,
				isLoading: false,
				isBackgroundLoading: false,
				selected: selected
			}

		case 'RECEIVE_OFFERS_DATA':
			return {
				...state,
				offersById: payload
			}
	}

	return state
}
